// eslint-disable-next-line no-unused-vars
import { useField, FieldAttributes, useFormikContext } from 'formik';
import React from 'react';
import { FormFieldError } from '../FormFields/FieldError';
import { FieldInput } from '../FormFields/FieldInput';
import clsx from 'clsx';
import { LabelPosition } from '../../types';

type FormikTextInputProps = {
  label: React.ReactElement | string;
  labelPosition?: LabelPosition;
  disabled?: boolean | undefined;
  isRequired?: boolean;
  children?: React.ReactElement;
  fieldWrapperClasses?: string;
};

export const FormikTextInput = ({
  label,
  labelPosition = LabelPosition.TOP,
  isRequired,
  children,
  fieldWrapperClasses,
  ...props
}: FormikTextInputProps & FieldAttributes<{}>) => {
  // useField() returns [formik.getFieldProps(), formik.getFieldMeta()]
  // which we can spread on <input> and else replace ErrorMessage entirely.

  const [field, meta] = useField<{}>(props);
  const { isValidating } = useFormikContext();

  return (
    <div
      className={clsx('flex my-2', labelPosition === LabelPosition.TOP ? 'flex-col' : 'items-baseline justify-between')}
    >
      <label
        data-testid={`label-for-${field.name}`}
        className={clsx(
          'block mb-2 tracking-wide font-effra',
          labelPosition === LabelPosition.TOP ? 'text-sm font-bold' : 'text-base',
          props.disabled ? 'text-gray-20' : 'text-black-default'
        )}
        htmlFor={field.name}
      >
        {label}
        {isRequired && <span className='px-1'>*</span>}
      </label>
      <div className={fieldWrapperClasses}>
        <FieldInput field={field} meta={meta} {...props} hideError={isValidating}>
          {children}
        </FieldInput>
        <FormFieldError field={field} meta={meta} hideError={isValidating} />
      </div>
    </div>
  );
};
